/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import{c as s}from"../../../../../chunks/vec4f64.js";import{ColorMixModeEnum as o}from"../../../layers/support/symbolColorUtils.js";class t{constructor(){this.externalColor=s(),this.externalColorMixMode=o.Multiply,this.castShadows=!0,this.pickable=!0,this.elevationOffset=0}}export{t as UniformComponentParameters};
